module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#video-play",
      toString: function () {
        return this.url;
      }
    }